import { listQueryToApiParams } from '#/utils/listUrl/parseListSearchParams';

/**
 * status／voucher_type 多值以逗號送；sort id 送 snake_case。
 * voucher_no（逗號片段 OR）、total_amount_min／max、voucher_date_from／to 為單值，
 * camel key 由共用 listQueryToApiParams 轉 snake（be doc abbce90d）。
 */
function sortIdToSnake(id) {
  return String(id || '').replace(/[A-Z]/g, (char) => `_${char.toLowerCase()}`);
}

function joinCommaFilter(filters, key) {
  const value = filters[key];
  if (Array.isArray(value) && value.length > 0) {
    filters[key] = value.filter(Boolean).join(',');
  }
}

export function voucherListQueryToApiParams(listQuery) {
  const filters = { ...(listQuery?.filters || {}) };
  joinCommaFilter(filters, 'status');
  joinCommaFilter(filters, 'voucherType');

  const sort = (listQuery?.sort || []).map(({ id, desc }) => ({
    id: sortIdToSnake(id),
    desc: Boolean(desc),
  }));

  return listQueryToApiParams({
    ...listQuery,
    filters,
    sort,
  });
}
